import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps, Typography } from '@mui/material';

import { LocalizationContext } from '@cvt/contexts';


export type PetSexSelectProps = Omit<SelectProps<string | null>, 'renderValue'> & {
  error?: boolean;
  helperText?: React.ReactNode;
};

export const PetSexSelect = React.forwardRef<HTMLDivElement, PetSexSelectProps>(({ error, helperText, label, slotProps, ...props }, ref) => {

  const { dictionary } = React.useContext(LocalizationContext);
  const sexes = React.useMemo(() => {
    return [
      'male', 'female',
    ];
  },[]);

  return (
    <Box width="100%">
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          displayEmpty
          label={label}
          {...props}
          ref={ref}
          color="primary"
          renderValue={(selected) => {
            const sex = sexes.find((sex) => sex === selected);
            if (!sex) {
              return (
                <span style={{ color: '#a2a2a2' }}>
                  {dictionary.forms.tributes.sexPlaceholder}
                </span>
              );
            }
            return (
              <Typography sx={{ textTransform: 'capitalize' }}>{sex}</Typography>
            );
          }}
          MenuProps={{
            ...props.MenuProps,
            PaperProps: {
              ...props.MenuProps?.PaperProps,
              sx: {
                maxHeight: (36 * 8.5) + 8,
              },
            },
          }}
          error={error}
        >
          <MenuItem value="">
            <span style={{ color: '#a2a2a2' }}>
              {dictionary.forms.tributes.sexPlaceholder}
            </span>
          </MenuItem>
          {sexes.map((sex) => (
            <MenuItem key={sex} value={sex}  sx={{ textTransform: 'capitalize' }}>
              {sex}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!!helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </Box>
  );
});
